<template>
  <drop-file
    class="dialog-drop-file"
    :style="{backgroundColor: 'white'}"
    @rawFilesChanged="$store.dispatch('dialog/setData', $event)" />
</template>

<script>
  import DropFile from '~/components/common/DropFile.vue'

  export default {
    name: 'dialog-upload-file',
    components: {DropFile}
  }
</script>

<style lang="scss">

  .dialog-drop-file .drop-box {
    transition: none !important;
    padding: 3rem 0 3rem 0 !important;

    &.has-files {
      padding: 3rem 0 1rem 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogUploadFiles.vue